import { HeadLine } from "../../../layouts/headers/HeadLine"
import CSS from 'csstype';
import CounterComponent from "../../../components/counter/CounterComponent";
import GeneralButtonComponent from "../../../components/button/GeneralButtonComponent";

export const SelectOneFood = () => {

    const bgimage: CSS.Properties = { backgroundImage: 'url(../../../../assets/img/svg/omelette_bg.svg)' };


    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Room Service' backurl='/room-service' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="flex justify-center items-center" style={msgWarnStyle}>
                    <span>Este servicio no tiene ningún costo</span>
                </div>
                <div className="bg_detail_food" style={bgimage}>

                </div>
            </div>

            <div className="absolute z-1 w-full border shadow detail-process-food-container pb-4">
                <div className="mt-4" style={typeFoodstyles}>Omelette</div>
                <p className="mt-4" style={{fontSize:'14px'}}>
                    Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de Alimento Detalle de A.
                </p>

                <div className="mt-4" style={typeFoodstyles}>Complementos</div>

                <div className="customchecks mt-4">
                    <label className="containercheck">Jamón
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                    </label>
                    <label className="containercheck">Queso Manchego
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                    </label>
                    <label className="containercheck">Queso Panela
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                    </label>
                    <label className="containercheck">Queso Badota
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                    </label>
                    <label className="containercheck">Champiñones
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                    </label>
                </div>

                <div className="mt-8">
                    Número de Órdenes: <span style={{color:'#67BAAF'}}>Máximo 2</span> 
                </div>

                <div className="mt-4 flex justify-between">
                    <CounterComponent/>
                    <GeneralButtonComponent classes="primary_btn hover:primary_btn text-white py-2 px-6"  bgcolor="#67BAAF">Solicitar</GeneralButtonComponent>
                </div>
            </div>

        </>
    )
}

const msgWarnStyle: CSS.Properties = {
    color: '#012349',
    height: '40px',
    fontSize: '14px',
    backgroundColor: '#FFE36F',
    width: '100vw',
    marginLeft: '-14px',
    marginTop: '-14px',
    fontWeight: '600'
}

const typeFoodstyles: CSS.Properties = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#012349',
    lineHeight: '18px'
}
